import 'consumerweb-shim';
import React from 'react'
import PropTypes from 'prop-types'
import $ from 'jquery'
import { Router, Route, browserHistory } from 'react-router'
import { render } from 'react-dom'

import CookiedUserPage from './../pages/landing/landing'
import GuestPage from './../pages/guest/guest'
import CrossBorder from './../pages/guest/crossBorder'
import GuestConfirmation from './../pages/guest/confirmation'
import GuestPending from './../pages/guest/pending'
import PaymentError from './../pages/error/paymentError'
import templateData from './../utility/getTemplateData'

const { currentState, currentUserState } = templateData

const LandingPage = React.createClass({

	contextTypes: {
		router: PropTypes.object.isRequired
	},

	getInitialState: function() {

		return {
			userCookied: currentUserState === 'cookied'
		}
	},

	componentDidMount() {

		if (currentState) {
			this.context.router.push(currentState)
		}
		$('.spinneroverlay').hide();
	},

	render() {
		return (
			<div>{this.state.userCookied ? <CookiedUserPage/> : <GuestPage />}</div>
		)
	}
})

render((
	<Router history={browserHistory}>
		<Route path="/donate" component={LandingPage} />
		<Route path="/donate/guest" component={GuestPage} />
		<Route path="/donate/guest/crossborder" component={CrossBorder} />
		<Route path="/donate/guest/confirmation" component={GuestConfirmation} />
		<Route path="/donate/guest/pending" component={GuestPending} />
		<Route path="/donate/error/payment" component={PaymentError} />
	</Router>
), document.getElementById('donateWrapper'))



// WEBPACK FOOTER //
// ./routes/router.js